module.exports = __webpack_public_path__ + "static/media/chevron-up.d334376a.svg";